import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSlideArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 8 26"
    stroke="#919499"
    strokeLinecap="round"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m1 1 6 12-6 12" />
  </svg>
);
const Memo = memo(SvgSlideArrow);
export default Memo;
